var _firebase$messaging;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//@ts-nocheck

import { Message } from "../../../framework/src/Message";
import { BlockComponent } from "../../../framework/src/BlockComponent";
import MessageEnum, { getName } from "../../../framework/src/Messages/MessageEnum";
import { runEngine } from "../../../framework/src/RunEngine";

// Customizable Area Start
import mqtt from 'mqtt';
import jsPDF from "jspdf";
import "jspdf-autotable";
import { getDeviceDetailFromLocationObjBySid, getformatedYesterDayDate, getformatedCurrentDate, getUserInfo, skipped, down } from "./utility";
import { toast } from "react-toastify";
import firebase from 'firebase/compat/app';
import 'firebase/messaging';
import moment from "moment";
const firebaseConfig = {
  apiKey: "AIzaSyCfwZYSSGodlGTJi1qWjNhPiGQ2TQvL8ko",
  authDomain: "esskayssystems.firebaseapp.com",
  projectId: "esskayssystems",
  storageBucket: "esskayssystems.appspot.com",
  messagingSenderId: "79025972560",
  appId: "1:79025972560:web:dd5bd40318161337bbf855",
  measurementId: "G-28YB6EJ1DR"
};
if (!(firebase !== null && firebase !== void 0 && firebase.apps.length)) {
  firebase === null || firebase === void 0 || firebase.initializeApp(firebaseConfig);
} else {
  firebase === null || firebase === void 0 || firebase.app(); // if already initialized, use that one
}
const messaging = firebase !== null && firebase !== void 0 && (_firebase$messaging = firebase.messaging) !== null && _firebase$messaging !== void 0 && _firebase$messaging.isSupported() ? firebase === null || firebase === void 0 ? void 0 : firebase.messaging() : null;
const configJSON = require("./config.js");
// Customizable Area End

export default class DashboardController extends BlockComponent {
  // Customizable Area End
  constructor(props) {
    var _userInfo$data$attrib, _userInfo, _userInfo$data$attrib2, _userInfo2, _userInfo3;
    super(props);
    // Customizable Area Start
    _defineProperty(this, "apiDashboardItemCallId", "");
    _defineProperty(this, "dashboardApiCallId", "");
    _defineProperty(this, "apiGetQueryStrinurl", "");
    _defineProperty(this, "apiGetCounterId", "");
    _defineProperty(this, "mqttConnectionConnected", false);
    _defineProperty(this, "notifiedTargetReactedApi", false);
    // Customizable Area Start
    _defineProperty(this, "getTargetSettingsApiCall", responseJson => {
      if (responseJson.data) {
        if (Object.keys(responseJson.data).length !== 0) {
          var _responseJson$data;
          const targetObj = responseJson === null || responseJson === void 0 || (_responseJson$data = responseJson.data) === null || _responseJson$data === void 0 ? void 0 : _responseJson$data.attributes;
          this.setState(prevState => _objectSpread(_objectSpread({}, prevState), {}, {
            targetData: targetObj
          }));
        } else {
          toast.error("This Device May be Removed for You");
        }
      } else {
        if (responseJson.message) {
          this.showErrorToast(responseJson);
        } else {
          toast.error("Something went wrong");
        }
      }
    });
    _defineProperty(this, "apiGetDeviceCounter", responseJson => {
      if (responseJson.data) {
        this.setState(prevState => _objectSpread(_objectSpread({}, prevState), {}, {
          deviceCounter: responseJson.data
        }));
      }
      if (responseJson.message) {
        toast.error("Error! " + responseJson.message);
      }
    });
    _defineProperty(this, "getNotificationCountApi", responseJson => {
      (responseJson === null || responseJson === void 0 ? void 0 : responseJson.unread_count) && this.setState(prevState => _objectSpread(_objectSpread({}, prevState), {}, {
        notificationCount: (responseJson === null || responseJson === void 0 ? void 0 : responseJson.unread_count) || 0
      }));
    });
    _defineProperty(this, "generateOtpApi", responseJson => {
      if (responseJson.meta.token) {
        this.setState({
          showClearModal: true,
          otpObj: {
            token: responseJson.meta.token,
            otp: ''
          },
          showLoader: false
        });
      } else {
        this.setState({
          clearType: "",
          showLoader: false
        });
        if (responseJson.message) {
          this.showErrorToast(responseJson);
        } else {
          toast.error("Something went wrong");
        }
      }
    });
    _defineProperty(this, "validateOtpApiCall", responseJson => {
      this.setState({
        showClearModal: false
      });
      if (responseJson.message) {
        toast.success(this.state.clearType == "clearData" ? "Clear Data command sent successfully." : "Zero Calibrate command sent successfully.");
        this.publishData();
      } else {
        if (responseJson.errors[0] && responseJson.errors[0].otp) {
          toast.error(responseJson.errors[0].otp);
        } else {
          toast.error("Something went wrong");
        }
      }
    });
    _defineProperty(this, "getSelectedFlowRateApiCall", responseJson => {
      if (responseJson !== null && responseJson !== void 0 && responseJson.data) {
        this.setState(prevState => {
          var _responseJson$data2, _responseJson$data3, _responseJson$data4, _responseJson$data5;
          return _objectSpread(_objectSpread({}, prevState), {}, {
            chartLabels: responseJson === null || responseJson === void 0 || (_responseJson$data2 = responseJson.data) === null || _responseJson$data2 === void 0 ? void 0 : _responseJson$data2.map(value => value.time ? value.time : value.date),
            chartFlowData: responseJson === null || responseJson === void 0 || (_responseJson$data3 = responseJson.data) === null || _responseJson$data3 === void 0 ? void 0 : _responseJson$data3.map(value => value.flow),
            maxArray: responseJson === null || responseJson === void 0 || (_responseJson$data4 = responseJson.data) === null || _responseJson$data4 === void 0 ? void 0 : _responseJson$data4.map(value => ""),
            minArray: responseJson === null || responseJson === void 0 || (_responseJson$data5 = responseJson.data) === null || _responseJson$data5 === void 0 ? void 0 : _responseJson$data5.map(value => ""),
            showLoader: false,
            lineChartLoader: false
          });
        });
      } else {
        this.setState(prevState => _objectSpread(_objectSpread({}, prevState), {}, {
          showLoader: false
        }));
        if (responseJson.message) {
          this.showErrorToast(responseJson);
        } else {
          toast.error("Something went wrong");
        }
      }
    });
    _defineProperty(this, "getSelectedModalFlowRateApiCall", responseJson => {
      if (responseJson !== null && responseJson !== void 0 && responseJson.data) {
        var _responseJson$data6, _responseJson$data7, _responseJson$data8, _responseJson$data9;
        const labels = responseJson === null || responseJson === void 0 || (_responseJson$data6 = responseJson.data) === null || _responseJson$data6 === void 0 ? void 0 : _responseJson$data6.map(value => value.time ? value.time : value.date);
        const chartDataModal = responseJson === null || responseJson === void 0 || (_responseJson$data7 = responseJson.data) === null || _responseJson$data7 === void 0 ? void 0 : _responseJson$data7.map(value => value.flow);
        const lineDataModal = {
          labels,
          datasets: [{
            label: 'Dataset 1',
            data: chartDataModal,
            borderColor: 'rgb(255, 99, 132)',
            backgroundColor: 'rgba(255, 9, 132, 0.5)',
            segment: {
              borderColor: ctx => skipped(ctx, 'rgb(0,0,0,0.2)') || down(ctx, 'rgb(192,75,75)'),
              borderDash: ctx => skipped(ctx, [6, 6])
            },
            spanGaps: true,
            tension: 0.3
          }, {
            label: 'Min Flow',
            fill: false,
            radius: 0,
            borderColor: 'rgb(0, 0, 0)',
            backgroundColor: 'rgba(0,0, 0, 0)',
            borderDash: [8, 5],
            data: responseJson === null || responseJson === void 0 || (_responseJson$data8 = responseJson.data) === null || _responseJson$data8 === void 0 ? void 0 : _responseJson$data8.map(() => this.state.targetData.min_flow)
          }, {
            label: 'Max Flow',
            fill: false,
            radius: 0,
            borderColor: 'rgb(0, 0, 0)',
            backgroundColor: 'rgba(0,0, 0, 0)',
            borderDash: [8, 5],
            data: responseJson === null || responseJson === void 0 || (_responseJson$data9 = responseJson.data) === null || _responseJson$data9 === void 0 ? void 0 : _responseJson$data9.map(() => this.state.targetData.max_flow)
          }]
        };
        this.setState(prevState => _objectSpread(_objectSpread({}, prevState), {}, {
          chartFlowDataModal: lineDataModal,
          showLoaderModal: false
        }));
      } else {
        this.setState(prevState => _objectSpread(_objectSpread({}, prevState), {}, {
          showLoaderModal: false
        }));
        if (responseJson.message) {
          this.showErrorToast(responseJson);
        } else {
          toast.error("Something went wrong");
        }
      }
    });
    _defineProperty(this, "processDeviceData", responseJson => {
      const newData = responseJson.data.map(item => {
        const avg_flow = item !== null && item !== void 0 && item.avg_flow ? item === null || item === void 0 ? void 0 : item.avg_flow.toFixed(2) : 0;
        const avg_speed = item !== null && item !== void 0 && item.avg_speed ? item === null || item === void 0 ? void 0 : item.avg_speed.toFixed(2) : 0;
        const avg_load = item !== null && item !== void 0 && item.avg_load ? item === null || item === void 0 ? void 0 : item.avg_load.toFixed(2) : 0;
        const productionFixed = item !== null && item !== void 0 && item.weight ? item === null || item === void 0 ? void 0 : item.weight.toFixed(2) : 0;
        const runTime = item !== null && item !== void 0 && item.run_time ? "".concat(item.run_time) : "00:00";
        const idleTime = item !== null && item !== void 0 && item.idle_time ? "".concat(item.idle_time) : "00:00";
        const downTime = item !== null && item !== void 0 && item.down_time ? "".concat(item.down_time) : "00:00";
        return _objectSpread(_objectSpread({}, item), {}, {
          avg_flow: avg_flow,
          avg_speed: avg_speed,
          avg_load: avg_load,
          run_time: runTime,
          idle_time: idleTime,
          down_time: downTime,
          weight: productionFixed
        });
      });
      return newData;
    });
    _defineProperty(this, "handleNoDeviceData", (responseJson, dataType) => {
      if (dataType === "loadMore") {
        const oldData = _objectSpread({}, this.state.deviceReportsList);
        oldData.loadMore = false;
        this.setState({
          deviceReportsList: oldData
        });
      } else {
        this.setState({
          deviceReportsList: {
            data: [],
            loader: false,
            page_count: 1,
            current_page: 1
          }
        });
      }
    });
    _defineProperty(this, "getDeviceReportsApi", (responseJson, apiRequestCallId) => {
      const dataType = apiRequestCallId === this.getDeviceReportsLoadMoreApiId ? "loadMore" : "default";
      if (responseJson.data) {
        const newData = this.processDeviceData(responseJson);
        if (dataType === "loadMore") {
          const oldData = _objectSpread({}, this.state.deviceReportsList);
          oldData.data = [...oldData.data, ...newData];
          oldData.loadMore = false;
          this.setState({
            deviceReportsList: oldData
          });
        } else {
          var _responseJson$meta, _responseJson$meta2;
          this.setState({
            deviceReportsList: {
              data: newData,
              loader: false,
              page_count: ((_responseJson$meta = responseJson.meta) === null || _responseJson$meta === void 0 ? void 0 : _responseJson$meta.page_count) || 1,
              current_page: ((_responseJson$meta2 = responseJson.meta) === null || _responseJson$meta2 === void 0 ? void 0 : _responseJson$meta2.current_page) || 1
            }
          });
        }
      } else {
        this.handleNoDeviceData();
        if (responseJson.message) {
          this.showErrorToast(responseJson);
        } else {
          toast.error("Something went wrong");
        }
      }
    });
    _defineProperty(this, "getLogsByDeviceId", responseJson => {
      const logObj = _objectSpread({}, this.state.logs);
      logObj.loader = false;
      if (responseJson && Object.entries(responseJson).length > 0) {
        logObj.low_flow = responseJson.low_flow;
        logObj.max_flow = responseJson.max_flow;
        logObj.started = responseJson.started;
        logObj.stoped = responseJson.stoped;
        let logsArray = [{
          name: "Event:  Started",
          date: responseJson.started
        }, {
          name: "Event:  Low Flow",
          date: responseJson.low_flow
        }, {
          name: "Event:  High Flow",
          date: responseJson.max_flow
        }, {
          name: "Event:  Stopped",
          date: responseJson.stoped
        }];
        let sortedlogsArray = [...logsArray].sort((a, b) => {
          var _b$date, _a$date;
          return (_b$date = b.date) === null || _b$date === void 0 ? void 0 : _b$date.split('/').reverse().join().localeCompare((_a$date = a.date) === null || _a$date === void 0 ? void 0 : _a$date.split('/').reverse().join());
        });
        logObj.logsArray = sortedlogsArray;
      } else {
        if (responseJson.message) {
          this.showErrorToast(responseJson);
        } else {
          toast.error("Something went wrong");
        }
      }
      this.setState({
        logs: logObj
      });
    });
    _defineProperty(this, "updateTargetLoadApi", responseJson => {
      if (responseJson.message) {
        this.showErrorToast(responseJson);
      }
      responseJson.status == 200 && setTimeout(() => window.location.reload(), 2000);
    });
    _defineProperty(this, "getDevicesLocationWiseCall", responseJson => {
      const newData = responseJson.data ? responseJson.data.map(devicesObj => {
        const devicesArr = Object.values(devicesObj)[0];
        const onbjKey = Object.keys(devicesObj)[0];
        const objVal = devicesArr.map(item => _objectSpread(_objectSpread({}, item), {}, {
          loading: true
        }));
        return {
          [onbjKey]: objVal
        };
      }) : [];
      localStorage.setItem("locationWiseDevices", JSON.stringify(newData));
      this.setState({
        locationWiseDevicesLoad: false,
        locationWiseDevices: newData
      });
      this.locationWiseDevicesLoad = false;
    });
    _defineProperty(this, "removeFirebaseTokenApi", responseJson => {
      if (responseJson.message) {
        localStorage.removeItem("token");
        localStorage.removeItem("userInfo");
        localStorage.removeItem("userId");
        localStorage.removeItem("devicesMqtt");
        localStorage.removeItem("tokenExpire");
        localStorage.removeItem("locationWiseDevices");
        window.location.href = "/EmailAccountLoginBlock";
      }
    });
    _defineProperty(this, "updateDeviceInformation", async prd => {
      const params = window.location.pathname.split("/");
      const deviceObj = params ? await getDeviceDetailFromLocationObjBySid(params[3], params[4]) : {};
      const data = prd ? [prd, 100 - prd] : [10];
      const deviceChatObj = {
        labels: [deviceObj === null || deviceObj === void 0 ? void 0 : deviceObj.sid_name],
        datasets: [{
          label: 'Speed of Devices',
          data: data,
          backgroundColor: [deviceObj === null || deviceObj === void 0 ? void 0 : deviceObj.sid_color, prd ? "#ffffff" : ""],
          borderColor: [deviceObj === null || deviceObj === void 0 ? void 0 : deviceObj.sid_color],
          borderWidth: 1
        }]
      };
      this.setState(prevState => _objectSpread(_objectSpread({}, prevState), {}, {
        deviceData: {
          chartData: deviceChatObj,
          deviceInfo: deviceObj
        }
      }));
    });
    _defineProperty(this, "getNotificationMsg", () => {
      new Promise(resolve => {
        messaging === null || messaging === void 0 || messaging.onMessage(payload => {
          var _payload$notification, _payload$notification2;
          toast.info("New Notification! ".concat(payload === null || payload === void 0 || (_payload$notification = payload.notification) === null || _payload$notification === void 0 ? void 0 : _payload$notification.title, " - ").concat(payload === null || payload === void 0 || (_payload$notification2 = payload.notification) === null || _payload$notification2 === void 0 ? void 0 : _payload$notification2.body));
          this.setState(prevState => _objectSpread(_objectSpread({}, prevState), {}, {
            notificationCount: prevState.notificationCount + 1
          }));
          resolve(payload);
        });
      });
    });
    _defineProperty(this, "getToken", () => {
      const token = localStorage.getItem('token');
      const tokenExpire = localStorage.getItem('tokenExpire');
      const tokenExpireDate = tokenExpire ? new Date(new Date(tokenExpire).getTime() + 24 * 60 * 60 * 1000) : new Date();
      const newDate = new Date();
      if (newDate > tokenExpireDate) {
        this.handleLogout();
      }
      if (!token) {
        window.location.href = '/';
      }
    });
    _defineProperty(this, "saveFireBase", () => {
      let fireBaseToken = localStorage.getItem('fireBaseToken');
      if (fireBaseToken) {
        this.saveFirebaseToken(fireBaseToken);
      } else {
        messaging === null || messaging === void 0 || messaging.getToken({
          vapidKey: 'BGUWXMkNdmqVs7h9RtApqAxUME6FLndmIUpf07BVl47ORl3jT6iGvnRKN3zVyiYZ3sxVYVUhq6Kw_JjdbibOUPo'
        }).then(currentToken => {
          if (currentToken) {
            localStorage.setItem("fireBaseToken", currentToken);
            this.saveFirebaseToken(currentToken);
          }
        }).catch(err => {
          console.log('An error occurred while retrieving token. ', err);
        });
      }
    });
    _defineProperty(this, "saveFirebaseToken", firebaseToken => {
      const header = {
        "Content-Type": configJSON.dashboarContentType,
        token: localStorage.getItem("token")
      };
      const requestMessage = new Message(getName(MessageEnum.RestAPIRequestMessage));
      //GO TO REQUEST STATE
      this.saveFireBaseTokeApiID = requestMessage.messageId;
      requestMessage.addData(getName(MessageEnum.RestAPIResponceEndPointMessage), "notification_token");
      requestMessage.addData(getName(MessageEnum.RestAPIRequestHeaderMessage), JSON.stringify(header));
      requestMessage.addData(getName(MessageEnum.RestAPIRequestMethodMessage), "POST");
      const httpBody = {
        "notification_token": firebaseToken
      };
      requestMessage.addData(getName(MessageEnum.RestAPIRequestBodyMessage), JSON.stringify(httpBody));
      runEngine.sendMessage(requestMessage.id, requestMessage);
      return true;
    });
    _defineProperty(this, "scrollToBottom", () => {
      var _window;
      const params = (_window = window) === null || _window === void 0 || (_window = _window.location) === null || _window === void 0 ? void 0 : _window.search;
      if (params.trim() == "?scroll=bottom") {
        var _window2;
        (_window2 = window) === null || _window2 === void 0 || _window2.scrollTo(0, document.body.scrollHeight);
      }
    });
    _defineProperty(this, "filterFieldChange", e => {
      const filterName = e.target.name;
      const filterObj = _objectSpread({}, this.state.filterObj);
      if (filterName == "start_date") {
        filterObj['startDateValid'] = true;
        filterObj['startDateMsg'] = '';
      }
      if (filterName == 'start_date') {
        filterObj['endDateValid'] = true;
        filterObj['endDateMsg'] = '';
      }
      const today = new Date();
      const enteredDate = new Date(e.target.value);
      if (enteredDate <= today) {
        filterObj[filterName] = e.target.value;
      }
      this.setState({
        filterObj: filterObj
      });
    });
    _defineProperty(this, "getMqttData", () => {
      const {
        modems
      } = this.state;
      if (!this.locationWiseDevicesLoad && !this.mqttConnectionConnected && modems && modems.data && modems.data.length) {
        // this.mqttConnection = mqtt.connect('mqtts://mqtt.esskayconnect.com', {
        //   username: 'user',
        //   password: 'password',
        //   port: 8083,
        // });
        this.mqttConnection = mqtt.connect('mqtts://mqtt-prod.esskayconnect.com', {
          username: 'esskay_mqtt',
          password: configJSON.password,
          port: 8883
        });
        console.log('connect obj-', this.mqttConnection);
        this.mqttConnection.on('connect', () => console.log('connected to mqtt'));
        this.mqttConnectionConnected = true;
        modems.data.map((item, i) => {
          var _item$attributes, _item$attributes2, _item$attributes3, _item$attributes4;
          (item === null || item === void 0 || (_item$attributes = item.attributes) === null || _item$attributes === void 0 ? void 0 : _item$attributes.imei_number) && this.mqttConnection.subscribe((item === null || item === void 0 || (_item$attributes2 = item.attributes) === null || _item$attributes2 === void 0 ? void 0 : _item$attributes2.imei_number) + '/event');
          (item === null || item === void 0 || (_item$attributes3 = item.attributes) === null || _item$attributes3 === void 0 ? void 0 : _item$attributes3.device_imei_number) && this.mqttConnection.subscribe((item === null || item === void 0 || (_item$attributes4 = item.attributes) === null || _item$attributes4 === void 0 ? void 0 : _item$attributes4.device_imei_number) + '/event');
        });
        this.getMqttMessage();
      }
    });
    _defineProperty(this, "getMqttMessage", () => {
      this.mqttConnection.on('message', (topic, message) => {
        var _data$modbus$;
        console.log('message from mqtt-', message.toString());
        const {
          data
        } = JSON.parse(message.toString());
        if (data !== null && data !== void 0 && data.imei && data !== null && data !== void 0 && data.modbus && data !== null && data !== void 0 && data.modbus.length && data !== null && data !== void 0 && (_data$modbus$ = data.modbus[0]) !== null && _data$modbus$ !== void 0 && _data$modbus$.sid) {
          this.setState({
            showDashboardLoader: false
          });
          const processedData = this.processMQTTData(data);
          const params = window.location.pathname.split("/");
          if (params[2] == "DeviceInfo") {
            if (params[3] == processedData.imei) {
              this.handleDeviceInfoPageMqttData(processedData, params);
            }
          } else {
            this.handleDashboardPageMqttData(processedData);
          }
        }
      });
    });
    _defineProperty(this, "processMQTTData", data => {
      const dateDtm = "".concat(data.dtm.substr(0, 4), "/").concat(data.dtm.substr(4, 2), "/").concat(data.dtm.substr(6, 2), " ").concat(data.dtm.substr(8, 2), ":").concat(data.dtm.substr(10, 2), ":").concat(data.dtm.substr(12));
      const dtm = new Date(dateDtm);
      let currentDate = new Date();
      currentDate.setMinutes(currentDate.getMinutes() - 15);
      data.oldData = dtm < currentDate;
      const processedData = this.processMQTTData1(data);
      return processedData;
    });
    _defineProperty(this, "processMQTTData1", data => {
      var _data$modbus;
      let processedData;
      if (data !== null && data !== void 0 && data.modbus && (data === null || data === void 0 || (_data$modbus = data.modbus) === null || _data$modbus === void 0 ? void 0 : _data$modbus.length) > 1) {
        processedData = this.processMQTTData1Yes(data);
      } else {
        processedData = this.processMQTTData1No(data);
      }
      return processedData;
    });
    _defineProperty(this, "processMQTTData1Yes", data => {
      data === null || data === void 0 || data.modbus.map(deviceItem => {
        if (deviceItem.Load && Math.sign(deviceItem === null || deviceItem === void 0 ? void 0 : deviceItem.Load) === -1) {
          deviceItem["oldData"] = true;
        } else if (deviceItem.Flow && Math.sign(deviceItem.Flow) === -1) {
          deviceItem["oldData"] = true;
        } else {
          deviceItem["oldData"] = false;
        }
        if (deviceItem !== null && deviceItem !== void 0 && deviceItem.Load && (deviceItem === null || deviceItem === void 0 ? void 0 : deviceItem.Load) > 1000) {
          deviceItem['Load'] = 0;
        }
      });
      return data;
    });
    _defineProperty(this, "processMQTTData1No", data => {
      var _data$modbus$2, _data$modbus$3, _data$modbus$4, _data$modbus$5, _data$modbus$6, _data$modbus$7;
      if (data !== null && data !== void 0 && (_data$modbus$2 = data.modbus[0]) !== null && _data$modbus$2 !== void 0 && _data$modbus$2.Load && Math.sign(data === null || data === void 0 || (_data$modbus$3 = data.modbus[0]) === null || _data$modbus$3 === void 0 ? void 0 : _data$modbus$3.Load) === -1) {
        data.oldData = true;
      }
      if (data !== null && data !== void 0 && (_data$modbus$4 = data.modbus[0]) !== null && _data$modbus$4 !== void 0 && _data$modbus$4.Load && (data === null || data === void 0 || (_data$modbus$5 = data.modbus[0]) === null || _data$modbus$5 === void 0 ? void 0 : _data$modbus$5.Load) > 1000) {
        data.modbus[0].Load = 0;
      }
      if (data !== null && data !== void 0 && (_data$modbus$6 = data.modbus[0]) !== null && _data$modbus$6 !== void 0 && _data$modbus$6.Flow && Math.sign(data === null || data === void 0 || (_data$modbus$7 = data.modbus[0]) === null || _data$modbus$7 === void 0 ? void 0 : _data$modbus$7.Flow) === -1) {
        data.oldData = true;
      }
      return data;
    });
    _defineProperty(this, "handleDeviceInfoPageMqttData", (data, params) => {
      if (data.modbus && data.modbus.length > 1 && !data.oldData) {
        this.setDeviceInfoPageMqttData(data, params);
      } else if (params[4] == data.modbus[0].sid && !data.oldData) {
        const targetPrd = this.state.targetData.production ? this.state.targetData.production : 0;
        const prdPercentage = data.modbus[0].Total && targetPrd !== 0 ? Math.floor(data.modbus[0].Total / targetPrd * 100) : 0;
        prdPercentage !== 0 && this.updateDeviceInformation(prdPercentage);
        this.setState(prevState => ({
          deviceMqttData: data.modbus[0],
          currentProd: data.modbus[0] ? data.modbus[0].Total : prevState.currentProd,
          prdPercentage: prdPercentage
        }));
      }
    });
    _defineProperty(this, "setDeviceInfoPageMqttData", (data, params) => {
      data.modbus.map(multiDeviceItem => {
        if (params[4] == multiDeviceItem.sid && !multiDeviceItem.oldData) {
          const targetPrd = this.state.targetData.production ? this.state.targetData.production : 0;
          const prdPercentage = multiDeviceItem.Total && targetPrd !== 0 ? Math.floor(multiDeviceItem.Total / targetPrd * 100) : 0;
          prdPercentage !== 0 && this.updateDeviceInformation(prdPercentage);
          this.setState(prevState => ({
            deviceMqttData: multiDeviceItem,
            currentProd: multiDeviceItem ? multiDeviceItem.Total : prevState.currentProd,
            prdPercentage: prdPercentage
          }));
          return true;
        }
      });
    });
    _defineProperty(this, "handleDashboardPageMqttData", data => {
      let dataChanged = false;
      const locationWiseDevices = this.state.locationWiseDevices;
      locationWiseDevices.length > 0 && locationWiseDevices.map((devices, i) => {
        const devices2 = Object.values(devices)[0];
        const locationName = devices ? Object.keys(devices)[0] : [];
        devices2.map((subDevices, j) => {
          if (subDevices.imei == (data === null || data === void 0 ? void 0 : data.imei)) {
            var _data$modbus2, _data$modbus$8;
            if ((data === null || data === void 0 || (_data$modbus2 = data.modbus) === null || _data$modbus2 === void 0 ? void 0 : _data$modbus2.length) > 1) {
              var _data$modbus3;
              data === null || data === void 0 || (_data$modbus3 = data.modbus) === null || _data$modbus3 === void 0 || _data$modbus3.map(dev => {
                if ((dev === null || dev === void 0 ? void 0 : dev.sid) == subDevices.sub_device.sid) {
                  if (!(dev !== null && dev !== void 0 && dev.Flow)) {
                    dev.Flow = 0.00;
                  }
                  if (!(dev !== null && dev !== void 0 && dev.Speed)) {
                    dev.Speed = 0.00;
                  }
                  if (!(dev !== null && dev !== void 0 && dev.Total)) {
                    dev.Total = 0.00;
                  }
                  dev.disconnected = dev.stat == 21;
                  locationWiseDevices[i]["".concat(locationName)][j].loading = false;
                  if (!dev.oldData) {
                    locationWiseDevices[i]["".concat(locationName)][j].mqttData = data;
                  }
                  dataChanged = true;
                  return true;
                }
              });
            } else if ((data === null || data === void 0 || (_data$modbus$8 = data.modbus[0]) === null || _data$modbus$8 === void 0 ? void 0 : _data$modbus$8.sid) == subDevices.sub_device.sid) {
              var _data$modbus$9, _data$modbus$0, _data$modbus$1;
              if (!(data !== null && data !== void 0 && (_data$modbus$9 = data.modbus[0]) !== null && _data$modbus$9 !== void 0 && _data$modbus$9.Flow)) {
                data.modbus[0].Flow = 0.00;
              }
              if (!(data !== null && data !== void 0 && (_data$modbus$0 = data.modbus[0]) !== null && _data$modbus$0 !== void 0 && _data$modbus$0.Speed)) {
                data.modbus[0].Speed = 0.00;
              }
              if (!(data !== null && data !== void 0 && (_data$modbus$1 = data.modbus[0]) !== null && _data$modbus$1 !== void 0 && _data$modbus$1.Total)) {
                data.modbus[0].Total = 0.00;
              }
              data.modbus[0].disconnected = data.modbus[0].stat == 21;
              locationWiseDevices[i]["".concat(locationName)][j].loading = false;
              if (!data.oldData) {
                locationWiseDevices[i]["".concat(locationName)][j].mqttData = data;
              }
              dataChanged = true;
            }
          }
        });
      });
      dataChanged && locationWiseDevices.length > 0 && this.setState({
        locationWiseDevices: locationWiseDevices
      });
    });
    _defineProperty(this, "publishData", () => {
      const params = window.location.pathname.split("/");
      if (this.state.clearType == "clearData") {
        this.mqttConnectionConnected && this.mqttConnection.publish("".concat(params[3], "/command"), "$IPCFG,<DEVCMD: MBWR=".concat(params[4], ",6,8,165>"));
      } else if (this.state.clearType == "calibrate") {
        this.mqttConnectionConnected && this.mqttConnection.publish("".concat(params[3], "/command"), "$IPCFG,<DEVCMD: MBWR=".concat(params[4], ",6,58,33>"));
      }
      setTimeout(() => window.location.reload(), 2000);
    });
    _defineProperty(this, "showErrorToast", resObj => {
      if (resObj.message) {
        resObj.status !== 200 ? toast.error(resObj.message) : toast.success(resObj.message);
      }
    });
    _defineProperty(this, "openMenu", event => {
      if (event) {
        this.setState({
          anchorEl: event.currentTarget
        });
      }
    });
    _defineProperty(this, "handleMenuClose", () => {
      this.setState({
        anchorEl: null
      });
    });
    _defineProperty(this, "handleOtpChange", otp => {
      const otpObj = _objectSpread({}, this.state.otpObj);
      otpObj['otp'] = otp || '';
      this.setState({
        otpObj: otpObj
      });
    });
    _defineProperty(this, "validateDeviceFilterFields", () => {
      const filObj = _objectSpread({}, this.state.filterObj);
      if (filObj.start_date && filObj.end_date) {
        if (Date.parse(filObj.start_date) < Date.parse(filObj.end_date)) {
          filObj['startDateValid'] = true;
          filObj['startDateMsg'] = '';
          filObj['endDateValid'] = true;
          filObj['endDateMsg'] = '';
          this.setState({
            filterObj: filObj,
            deviceReportsList: {
              data: [],
              loader: true,
              page_count: 1,
              current_page: 1
            }
          });
          this.getDeviceFilteredReports('');
        } else {
          filObj['startDateValid'] = false;
          filObj['startDateMsg'] = 'please enter Valid date';
          this.setState({
            filterObj: filObj
          });
        }
      } else {
        if (filObj.start_date == '' || !filObj.start_date) {
          filObj['startDateValid'] = false;
          filObj['startDateMsg'] = 'please enter Valid date';
        }
        if (filObj.end_date == '' || !filObj.end_date) {
          filObj['endDateValid'] = false;
          filObj['endDateMsg'] = 'please enter Valid date';
        }
        this.setState({
          filterObj: filObj
        });
      }
    });
    _defineProperty(this, "resetFilter", () => {
      this.setState({
        filterObj: {
          start_date: '',
          end_date: '',
          startDateValid: true,
          endDateValid: true,
          startDateMsg: '',
          endDateMsg: ''
        },
        deviceReportsList: {
          data: [],
          loader: true,
          page_count: 1,
          current_page: 1
        }
      });
      this.getDeviceFilteredReports('default');
    });
    _defineProperty(this, "reportsNextPage", type => {
      const reportsData = _objectSpread({}, this.state.deviceReportsList);
      reportsData.loadMore = true;
      // reportsData.data = [];
      if (type == "next") {
        reportsData.current_page = reportsData.current_page + 1;
      } else {
        reportsData.current_page = parseInt(type);
      }
      this.setState({
        deviceReportsList: reportsData
      });
      this.getDeviceFilteredReports('loadMore');
    });
    _defineProperty(this, "getDeviceFilteredReports", async type => {
      let dataParams = "";
      const params = window.location.pathname.split("/");
      const deviceObj = params ? await getDeviceDetailFromLocationObjBySid(params[3], params[4]) : {};
      if (type == "default") {
        const startDate = await getformatedYesterDayDate('');
        const endDate = await getformatedCurrentDate('');
        dataParams = "&start_date=".concat(startDate, "&end_date=").concat(endDate, "&page_no=1");
        this.setState({
          filterObj: {
            start_date: startDate,
            end_date: endDate,
            startDateValid: true,
            endDateValid: true,
            startDateMsg: '',
            endDateMsg: ''
          },
          deviceReportsList: {
            data: [],
            loader: true,
            page_count: 1,
            current_page: 1
          }
        });
      } else if (type == "loadMore") {
        dataParams = "&start_date=".concat(this.state.filterObj.start_date, "&end_date=").concat(this.state.filterObj.end_date, "&page_no=").concat(this.state.deviceReportsList.current_page);
      } else {
        dataParams = "&start_date=".concat(this.state.filterObj.start_date, "&end_date=").concat(this.state.filterObj.end_date, "&page_no=1");
      }
      const header = {
        "Content-Type": configJSON.dashboarContentType,
        token: localStorage.getItem("token")
      };
      const requestMessage = new Message(getName(MessageEnum.RestAPIRequestMessage));
      if (type == "loadMore") {
        this.getDeviceReportsLoadMoreApiId = requestMessage.messageId;
      }
      this.getDeviceReportsApiId = requestMessage.messageId;
      requestMessage.addData(getName(MessageEnum.RestAPIResponceEndPointMessage), "device_detail_report?id=".concat(deviceObj === null || deviceObj === void 0 ? void 0 : deviceObj.id).concat(dataParams));
      requestMessage.addData(getName(MessageEnum.RestAPIRequestHeaderMessage), JSON.stringify(header));
      requestMessage.addData(getName(MessageEnum.RestAPIRequestMethodMessage), 'GET');
      runEngine.sendMessage(requestMessage.id, requestMessage);
      return true;
    });
    _defineProperty(this, "handleOtpSubmit", () => {
      if (this.state.otpObj.otp !== "") {
        const header = {
          "Content-Type": configJSON.dashboarContentType,
          token: localStorage.getItem("token")
        };
        const requestMessage = new Message(getName(MessageEnum.RestAPIRequestMessage));
        this.validateOtpApiCallId = requestMessage.messageId;
        requestMessage.addData(getName(MessageEnum.RestAPIResponceEndPointMessage), '/bx_block_cfmqttconsumer3/mqtt_otp_confirmations');
        const httpBody = {
          "data": {
            "token": this.state.otpObj.token,
            "otp_code": this.state.otpObj.otp
          }
        };
        requestMessage.addData(getName(MessageEnum.RestAPIRequestHeaderMessage), JSON.stringify(header));
        requestMessage.addData(getName(MessageEnum.RestAPIRequestMethodMessage), 'POST');
        requestMessage.addData(getName(MessageEnum.RestAPIRequestBodyMessage), JSON.stringify(httpBody));
        runEngine.sendMessage(requestMessage.id, requestMessage);
        return true;
      } else {
        const otpObj = _objectSpread({}, this.state.otpObj);
        otpObj['otpErrorMessage'] = "Please enter OTP.";
        this.setState({
          otpObj: otpObj
        });
      }
    });
    _defineProperty(this, "handleLogout", () => {
      const header = {
        "Content-Type": configJSON.dashboarContentType,
        token: localStorage.getItem("token")
      };
      const requestMessage = new Message(getName(MessageEnum.RestAPIRequestMessage));
      this.removeFirebaseTokenApiId = requestMessage.messageId;
      requestMessage.addData(getName(MessageEnum.RestAPIResponceEndPointMessage), "remove_notification_token");
      const httpBody = {
        notification_token: localStorage.getItem("fireBaseToken")
      };
      requestMessage.addData(getName(MessageEnum.RestAPIRequestHeaderMessage), JSON.stringify(header));
      requestMessage.addData(getName(MessageEnum.RestAPIRequestMethodMessage), 'POST');
      requestMessage.addData(getName(MessageEnum.RestAPIRequestBodyMessage), JSON.stringify(httpBody));
      runEngine.sendMessage(requestMessage.id, requestMessage);
      return true;
    });
    _defineProperty(this, "notifyTargetLoadReached", async () => {
      const params = window.location.pathname.split("/");
      const deviceObj = params ? await getDeviceDetailFromLocationObjBySid(params[3], params[4]) : {};
      const header = {
        "Content-Type": configJSON.dashboarContentType,
        token: localStorage.getItem("token")
      };
      const requestMessage = new Message(getName(MessageEnum.RestAPIRequestMessage));
      this.notifyTargetLoadReachedApi = requestMessage.messageId;
      requestMessage.addData(getName(MessageEnum.RestAPIResponceEndPointMessage), "target_notify?id=".concat(deviceObj === null || deviceObj === void 0 ? void 0 : deviceObj.id));
      const httpBody = {};
      requestMessage.addData(getName(MessageEnum.RestAPIRequestHeaderMessage), JSON.stringify(header));
      requestMessage.addData(getName(MessageEnum.RestAPIRequestMethodMessage), 'POST');
      requestMessage.addData(getName(MessageEnum.RestAPIRequestBodyMessage), JSON.stringify(httpBody));
      runEngine.sendMessage(requestMessage.id, requestMessage);
      return true;
    });
    _defineProperty(this, "getNotificationsUnreadCount", () => {
      const header = {
        "Content-Type": configJSON.dashboarContentType,
        token: localStorage.getItem("token")
      };
      const requestMessage = new Message(getName(MessageEnum.RestAPIRequestMessage));
      this.getNotificationCountApiID = requestMessage.messageId;
      requestMessage.addData(getName(MessageEnum.RestAPIResponceEndPointMessage), '/unread_notification_count');
      requestMessage.addData(getName(MessageEnum.RestAPIRequestHeaderMessage), JSON.stringify(header));
      requestMessage.addData(getName(MessageEnum.RestAPIRequestMethodMessage), 'GET');
      runEngine.sendMessage(requestMessage.id, requestMessage);
      return true;
    });
    _defineProperty(this, "getTargetSettings", async () => {
      const params = window.location.pathname.split("/");
      const deviceObj = params ? await getDeviceDetailFromLocationObjBySid(params[3], params[4]) : {};
      const header = {
        "Content-Type": configJSON.dashboarContentType,
        token: localStorage.getItem("token")
      };
      const requestMessage = new Message(getName(MessageEnum.RestAPIRequestMessage));
      this.getTargetSettingsApiCallId = requestMessage.messageId;
      requestMessage.addData(getName(MessageEnum.RestAPIResponceEndPointMessage), "device_target/".concat(deviceObj === null || deviceObj === void 0 ? void 0 : deviceObj.id));
      requestMessage.addData(getName(MessageEnum.RestAPIRequestHeaderMessage), JSON.stringify(header));
      requestMessage.addData(getName(MessageEnum.RestAPIRequestMethodMessage), 'GET');
      runEngine.sendMessage(requestMessage.id, requestMessage);
      return true;
    });
    _defineProperty(this, "handleSelectedFlowOption", (e, newValue) => {
      this.setState(_objectSpread(_objectSpread({}, this.state), {}, {
        showLoader: true,
        lineChartLoader: true,
        selectedFlowOption: e.target.value
      }));
      this.getSelectedFlowData("");
    });
    _defineProperty(this, "getCounterDetails", async id => {
      let sid;
      if (id !== "") {
        sid = id;
      } else {
        const params = window.location.pathname.split("/");
        const device = await getDeviceDetailFromLocationObjBySid(params[3], params[4]);
        sid = device === null || device === void 0 ? void 0 : device.id;
      }
      const header = {
        "Content-Type": configJSON.dashboarContentType,
        token: localStorage.getItem("token")
      };
      const requestMessage = new Message(getName(MessageEnum.RestAPIRequestMessage));
      this.apiGetCounterId = requestMessage.messageId;
      requestMessage.addData(getName(MessageEnum.RestAPIResponceEndPointMessage), "bx_block_cfmqttconsumer3/show_time?id=".concat(sid));
      requestMessage.addData(getName(MessageEnum.RestAPIRequestHeaderMessage), JSON.stringify(header));
      requestMessage.addData(getName(MessageEnum.RestAPIRequestMethodMessage), 'GET');
      runEngine.sendMessage(requestMessage.id, requestMessage);
      return true;
    });
    _defineProperty(this, "getSelectedFlowData", async id => {
      let sid;
      if (id !== "") {
        sid = id;
      } else {
        const params = window.location.pathname.split("/");
        const device = await getDeviceDetailFromLocationObjBySid(params[3], params[4]);
        sid = device === null || device === void 0 ? void 0 : device.id;
      }
      const header = {
        "Content-Type": configJSON.dashboarContentType,
        token: localStorage.getItem("token")
      };
      const requestMessage = new Message(getName(MessageEnum.RestAPIRequestMessage));
      this.getSelectedFlowRateApiCallId = requestMessage.messageId;
      requestMessage.addData(getName(MessageEnum.RestAPIResponceEndPointMessage), "flow_rate?id=".concat(sid, "&filter_by=").concat(this.state.selectedFlowOption));
      requestMessage.addData(getName(MessageEnum.RestAPIRequestHeaderMessage), JSON.stringify(header));
      requestMessage.addData(getName(MessageEnum.RestAPIRequestMethodMessage), 'POST');
      runEngine.sendMessage(requestMessage.id, requestMessage);
      return true;
    });
    _defineProperty(this, "showFullModalForFlowRate", () => {
      this.setState({
        showFlowTPHGraph: true
      });
      this.getSelectedFlowDataModal('');
    });
    _defineProperty(this, "getSelectedFlowDataModal", async id => {
      let sid;
      if (id !== "") {
        sid = id;
      } else {
        const params = window.location.pathname.split("/");
        const device = await getDeviceDetailFromLocationObjBySid(params[3], params[4]);
        sid = device === null || device === void 0 ? void 0 : device.id;
      }
      const header = {
        "Content-Type": configJSON.dashboarContentType,
        token: localStorage.getItem("token")
      };
      const requestMessage = new Message(getName(MessageEnum.RestAPIRequestMessage));
      this.getSelectedModalFlowRateApiCallId = requestMessage.messageId;
      requestMessage.addData(getName(MessageEnum.RestAPIResponceEndPointMessage), "flow_rate?id=".concat(sid, "&count=15&filter_by=").concat(this.state.selectedFlowOption));
      requestMessage.addData(getName(MessageEnum.RestAPIRequestHeaderMessage), JSON.stringify(header));
      requestMessage.addData(getName(MessageEnum.RestAPIRequestMethodMessage), 'POST');
      runEngine.sendMessage(requestMessage.id, requestMessage);
      return true;
    });
    _defineProperty(this, "handleBackDrop", () => {
      this.setState({
        showLoader: false
      });
    });
    _defineProperty(this, "exportCSVData", () => {
      const startDate = new Date(this.state.filterObj.start_date);
      const endDate = new Date(this.state.filterObj.end_date);
      const heading = [{
        "Date": "Date",
        "Start Time": "Start Time",
        "End Time": "End Time",
        "Run Time": "Run Time (Hours)",
        "Idle Time": "Idle Time (Hours)",
        "Down Time": "Down Time (Hours)",
        "Average Flow (TPH)": "Average Flow (TPH)",
        "Average Speed": "Average Speed",
        "Average Load": "Average Load",
        "Production in Tons": "Production in Tons"
      }];
      const fileData = this.state.deviceReportsList.data.map(item => ({
        "Date": item.date,
        "Start Time": item.start_time,
        "End Time": item.end_time,
        "Run Time": item.run_time,
        "Idle Time": item.idle_time,
        "Down Time": item.down_time,
        "Average Flow (TPH)": item.avg_flow,
        "Average Speed": item.avg_speed,
        "Average Load": item.avg_load,
        "Production in Tons": item.weight
      }));
      const forCSV = [...heading, ...fileData];
      const newCsv = forCSV.map(d => Object.values(d).join(",")).join("\n");
      var data = new Blob([newCsv], {
        type: 'text/csv'
      });
      var csvURL = window.URL.createObjectURL(data);
      var tempLink = document.createElement('a');
      tempLink.href = csvURL;
      tempLink.setAttribute('download', "reports".concat(startDate.toLocaleDateString(), "to").concat(endDate.toLocaleDateString(), ".csv"));
      tempLink.click();
    });
    _defineProperty(this, "addFooters", doc => {
      const pageCount = doc.internal.getNumberOfPages();
      doc.setFont('helvetica', 'italic');
      doc.setFontSize(8);
      for (var i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        doc.text("Esskay Systems | Printed on: ".concat(new Date().toDateString(), " ").concat(new Date().toLocaleTimeString()), doc.internal.pageSize.width / 2, 287, {
          align: 'center'
        });
      }
    });
    _defineProperty(this, "exportPDFData", async () => {
      var _JSON$parse;
      let deviceDetails = localStorage.getItem('userInfo');
      deviceDetails = localStorage.getItem('userInfo') ? (_JSON$parse = JSON.parse(deviceDetails)) === null || _JSON$parse === void 0 || (_JSON$parse = _JSON$parse.data) === null || _JSON$parse === void 0 || (_JSON$parse = _JSON$parse.attributes) === null || _JSON$parse === void 0 || (_JSON$parse = _JSON$parse.devices) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.data : [];
      const getDeviceName = () => {
        let subDevicesDetails;
        deviceDetails.map(item => item.attributes.device_imei_number == window.location.pathname.split("/")[3] && item.attributes.sub_devices.map(subItem => subItem.sid == window.location.pathname.split("/")[4] ? subDevicesDetails = subItem.sid_name : 0));
        return subDevicesDetails;
      };
      const deviceSidName = getDeviceName();
      let startDate = new Date(this.state.filterObj.start_date);
      let endDate = new Date(this.state.filterObj.end_date);
      startDate = moment(startDate).format("D/MM/YYYY HH:mm");
      endDate = moment(endDate).format("D/MM/YYYY HH:mm");
      const eskeyImage = require("../assets/EsskaySystemsLogo.png");
      const custmerName = await getUserInfo("userName");
      const heading = ["Date", "Start Time", "End Time", "Run Time (Hours)", "Idle Time (Hours)", "Down Time (Hours)", "Average Flow (TPH)", "Average Speed", "Average Load", "Production in Tons"];
      const doc = new jsPDF();
      var pageWidth = doc.internal.pageSize.width || doc.internal.pageSize.getWidth();
      const tableBody = this.state.deviceReportsList.data.map(item => {
        return [item.date, item.start_time, item.end_time, item.run_time, item.idle_time, item.down_time, item.avg_flow, item.avg_speed, item.avg_load, item.weight];
      });
      let docPageNumber = 1;
      doc.autoTable({
        head: [heading],
        body: [...tableBody],
        margin: {
          top: 55,
          left: 7,
          right: 7
        },
        styles: {
          minCellHeight: 11,
          halign: "center",
          valign: "top",
          fontSize: 8,
          padding: 0,
          margin: 0
        },
        headerStyles: {
          cellPadding: 1,
          lineWidth: 0,
          valign: 'middle',
          fontStyle: 'bold',
          halign: 'center',
          fontSize: 9
        },
        didDrawPage: function (data) {
          // Header
          // doc.page = 1;
          data.settings.margin.top = 15;
          if (docPageNumber == 1) {
            doc.addImage(eskeyImage, 'JPEG', 5, 5, 75, 30);
            doc.setFontSize(10);
            doc.text("From Date", 127, 10, {
              baseline: 'top'
            });
            doc.text(":  ".concat(startDate), 155, 10, {
              baseline: 'top'
            });
            doc.text("To Date", 127, 16, {
              baseline: 'top'
            });
            doc.text(":  ".concat(endDate), 155, 16, {
              baseline: 'top'
            });
            doc.text("Customer Name", 127, 22, {
              baseline: 'top'
            });
            doc.text(":  ".concat(custmerName), 155, 22, {
              baseline: 'top'
            });
            doc.text("Device Name", 127, 28, {
              baseline: 'top'
            });
            doc.text(":  ".concat(deviceSidName), 155, 28, {
              baseline: 'top'
            });
            doc.setFontSize(22);
            doc.setFont(undefined, 'bold');
            doc.text("PRODUCTION REPORTS", pageWidth / 2, 50, {
              align: 'center'
            });
          } else {}
          docPageNumber = 2;
        }
      });
      this.addFooters(doc);
      doc.save("reports".concat(startDate, "to").concat(endDate, ".pdf"));
      return false;
    });
    _defineProperty(this, "getLogDeviceList", async () => {
      var _subDevicesList$, _subDevicesList$2;
      const subDevicesList = await getUserInfo('subDevicesList');
      const logObj = _objectSpread({}, this.state.logs);
      logObj.id = (_subDevicesList$ = subDevicesList[0]) === null || _subDevicesList$ === void 0 ? void 0 : _subDevicesList$.id;
      logObj.sid_name = (_subDevicesList$2 = subDevicesList[0]) === null || _subDevicesList$2 === void 0 ? void 0 : _subDevicesList$2.sid_name;
      this.setState({
        subDevicesList: subDevicesList,
        logs: logObj
      });
      subDevicesList.length > 0 && this.getLogDetails(subDevicesList[0].id);
    });
    _defineProperty(this, "handleSelectedDeviceChange", (e, val) => {
      const logObj = _objectSpread({}, this.state.logs);
      logObj.loader = true;
      logObj.id = val.props.value;
      logObj.sid_name = val.props.children;
      this.setState({
        logs: logObj
      });
      this.getLogDetails(val.props.value);
    });
    _defineProperty(this, "getLogDetails", val => {
      const header = {
        "Content-Type": configJSON.dashboarContentType,
        token: localStorage.getItem("token")
      };
      const requestMessage = new Message(getName(MessageEnum.RestAPIRequestMessage));
      this.getLogsByDeviceIdApi = requestMessage.messageId;
      requestMessage.addData(getName(MessageEnum.RestAPIResponceEndPointMessage), "/account_block/show_logs?id=".concat(val));
      requestMessage.addData(getName(MessageEnum.RestAPIRequestHeaderMessage), JSON.stringify(header));
      requestMessage.addData(getName(MessageEnum.RestAPIRequestMethodMessage), 'GET');
      runEngine.sendMessage(requestMessage.id, requestMessage);
      return true;
    });
    _defineProperty(this, "validateTargetData", () => {
      const sub_device = _objectSpread({}, this.state.targetData);
      let errorTargetData = false;
      if ((sub_device === null || sub_device === void 0 ? void 0 : sub_device.min_flow) > (sub_device === null || sub_device === void 0 ? void 0 : sub_device.max_flow)) {
        sub_device['error_min_flow'] = true;
        errorTargetData = true;
      }
      if ((sub_device === null || sub_device === void 0 ? void 0 : sub_device.min_speed) > (sub_device === null || sub_device === void 0 ? void 0 : sub_device.max_speed)) {
        sub_device['error_min_speed'] = true;
        errorTargetData = true;
      }
      if ((sub_device === null || sub_device === void 0 ? void 0 : sub_device.min_load) > (sub_device === null || sub_device === void 0 ? void 0 : sub_device.max_load)) {
        sub_device['error_min_load'] = true;
        errorTargetData = true;
      }
      if (errorTargetData) {
        this.setState({
          targetData: sub_device
        });
      } else {
        this.updateTagetLoad();
      }
    });
    _defineProperty(this, "updateTagetLoad", () => {
      const header = {
        "Content-Type": configJSON.dashboarContentType,
        token: localStorage.getItem("token")
      };
      const requestMessage = new Message(getName(MessageEnum.RestAPIRequestMessage));
      //GO TO REQUEST STATE
      this.updateTargetLoadApiCall = requestMessage.messageId;
      requestMessage.addData(getName(MessageEnum.RestAPIResponceEndPointMessage), "set_target/".concat(this.state.targetData.id, "/"));
      requestMessage.addData(getName(MessageEnum.RestAPIRequestHeaderMessage), JSON.stringify(header));
      const httpBody = {
        sub_device: _objectSpread({}, this.state.targetData)
      };
      delete httpBody.sub_device.id;
      delete httpBody.sub_device.imei_number;
      delete httpBody.sub_device.sid;
      delete httpBody.sub_device.sid_color;
      delete httpBody.sub_device.sid_name;
      requestMessage.addData(getName(MessageEnum.RestAPIRequestMethodMessage), "POST");
      requestMessage.addData(getName(MessageEnum.RestAPIRequestBodyMessage), JSON.stringify(httpBody));
      runEngine.sendMessage(requestMessage.id, requestMessage);
      return true;
    });
    _defineProperty(this, "handleDashboardBackDrop", () => {
      this.setState({
        showDashboardLoader: false
      });
    });
    _defineProperty(this, "getDeviceDetailsLocationWise", () => {
      const header = {
        "Content-Type": configJSON.dashboarContentType,
        token: localStorage.getItem("token")
      };
      const requestMessage = new Message(getName(MessageEnum.RestAPIRequestMessage));
      this.getDevicesLocationWise = requestMessage.messageId;
      requestMessage.addData(getName(MessageEnum.RestAPIResponceEndPointMessage), '/account_block/devices');
      requestMessage.addData(getName(MessageEnum.RestAPIRequestHeaderMessage), JSON.stringify(header));
      requestMessage.addData(getName(MessageEnum.RestAPIRequestMethodMessage), 'GET');
      runEngine.sendMessage(requestMessage.id, requestMessage);
      return true;
    });
    this.receive = this.receive.bind(this);
    this.clearData = this.clearData.bind(this);
    this.handleOtpSubmit = this.handleOtpSubmit.bind(this);
    console.disableYellowBox = true;
    // Customizable Area Start
    this.subScribedMessages = [getName(MessageEnum.AccoutLoginSuccess), getName(MessageEnum.RestAPIResponceMessage), getName(MessageEnum.SessionSaveMessage), getName(MessageEnum.SessionResponseMessage)];
    let userInfo = localStorage.getItem('userInfo');
    userInfo = JSON.parse(userInfo);
    this.state = {
      dashboardData: [],
      errorMsg: "",
      token: "",
      loading: false,
      selectedPath: "",
      // The devices that we are getting from backend via local storage are actually modems (Which can have upto 32 devices connected)
      modems: (_userInfo$data$attrib = (_userInfo = userInfo) === null || _userInfo === void 0 || (_userInfo = _userInfo.data) === null || _userInfo === void 0 || (_userInfo = _userInfo.attributes) === null || _userInfo === void 0 ? void 0 : _userInfo.devices) !== null && _userInfo$data$attrib !== void 0 ? _userInfo$data$attrib : [],
      deviceData: {
        chartData: {
          labels: [],
          datasets: []
        },
        deviceInfo: {}
      },
      deviceCounter: {},
      deviceMqttData: {},
      devices: [],
      selectedDevice: 'stone stand',
      anchorEl: null,
      updatedDevicesObj: (_userInfo$data$attrib2 = (_userInfo2 = userInfo) === null || _userInfo2 === void 0 || (_userInfo2 = _userInfo2.data) === null || _userInfo2 === void 0 || (_userInfo2 = _userInfo2.attributes) === null || _userInfo2 === void 0 || (_userInfo2 = _userInfo2.devices) === null || _userInfo2 === void 0 ? void 0 : _userInfo2.data) !== null && _userInfo$data$attrib2 !== void 0 ? _userInfo$data$attrib2 : [],
      minFlow: 0,
      maxFlow: 0,
      minSpeed: 0,
      maxSpeed: 0,
      minLoad: 0,
      maxLoad: 0,
      production: 0,
      selectedFlowOption: "1 hour",
      notificationCount: 0,
      showClearModal: false,
      showFlowTPHGraph: false,
      otpObj: {
        token: '',
        otp: ''
      },
      clearType: '',
      userImg: (_userInfo3 = userInfo) === null || _userInfo3 === void 0 || (_userInfo3 = _userInfo3.data) === null || _userInfo3 === void 0 || (_userInfo3 = _userInfo3.attributes) === null || _userInfo3 === void 0 ? void 0 : _userInfo3.photo,
      chartFlowData: [],
      chartLabels: [],
      showLoader: false,
      filterObj: {
        start_date: '',
        end_date: '',
        startDateValid: true,
        endDateValid: true,
        startDateMsg: '',
        endDateMsg: ''
      },
      deviceReportsList: {
        data: [],
        loader: true,
        page_count: 1,
        current_page: 1
      },
      minArray: [],
      maxArray: [],
      chartFlowDataModal: {},
      showLoaderModal: true,
      currentProd: "",
      subDevicesList: [{
        sid_name: "loading...",
        id: ""
      }],
      logs: {
        sid_name: "",
        loader: true,
        id: "",
        start: "",
        low: "",
        high: "",
        stop: "",
        logsArray: [{
          name: "Event:  Started",
          date: ""
        }, {
          name: "Event:  Low Flow",
          date: ""
        }, {
          name: "Event:  High Flow",
          date: ""
        }, {
          name: "Event:  Stopped",
          date: ""
        }]
      },
      targetData: {},
      prdPercentage: 0,
      showDashboardLoader: true,
      locationWiseDevices: [],
      locationWiseDevicesLoad: true,
      lineChartLoader: true,
      deviceInfoIntialCall: false
    };
    // Customizable Area End
    runEngine.attachBuildingBlock(this, this.subScribedMessages);
  }
  async componentDidMount() {
    var _window3, _window4;
    super.componentDidMount();
    // Customizable Area Start
    this.scrollToBottom();
    this.getToken();
    if (this.isPlatformWeb() === false) {
      this.props.navigation.addListener('willFocus', () => {
        this.getToken();
      });
    }
    if (((_window3 = window) === null || _window3 === void 0 || (_window3 = _window3.location) === null || _window3 === void 0 || (_window3 = _window3.pathname) === null || _window3 === void 0 ? void 0 : _window3.split("/")[2]) == "DeviceInfo") {
      this.locationWiseDevicesLoad = false;
    }
    this.getMqttData();
    this.setState({
      selectedPath: (_window4 = window) === null || _window4 === void 0 || (_window4 = _window4.location) === null || _window4 === void 0 || (_window4 = _window4.pathname) === null || _window4 === void 0 ? void 0 : _window4.toLowerCase()
    });
    // Customizable Area End
  }
  getDashboardData() {
    // Customizable Area Start
    const header = {
      "Content-Type": configJSON.dashboarContentType,
      token: this.state.token
    };
    const requestMessage = new Message(getName(MessageEnum.RestAPIRequestMessage));
    this.apiDashboardItemCallId = requestMessage.messageId;
    requestMessage.addData(getName(MessageEnum.RestAPIResponceEndPointMessage), configJSON.dashboardGetUrl);
    requestMessage.addData(getName(MessageEnum.RestAPIRequestHeaderMessage), JSON.stringify(header));
    requestMessage.addData(getName(MessageEnum.RestAPIRequestMethodMessage), configJSON.dashboarApiMethodType);
    runEngine.sendMessage(requestMessage.id, requestMessage);
    // Customizable Area End
    return true;
  }
  async receive(from, message) {
    // Customizable Area Start
    if (getName(MessageEnum.RestAPIResponceMessage) === message.id) {
      const apiRequestCallId = message.getData(getName(MessageEnum.RestAPIResponceDataMessage));
      const responseJson = message.getData(getName(MessageEnum.RestAPIResponceSuccessMessage));
      message.getData(getName(MessageEnum.RestAPIResponceErrorMessage));
      if (apiRequestCallId === this.getTargetSettingsApiCallId) {
        this.getTargetSettingsApiCall(responseJson);
      } else if (apiRequestCallId === this.apiGetCounterId) {
        this.apiGetDeviceCounter(responseJson);
      } else if (apiRequestCallId === this.getNotificationCountApiID) {
        this.getNotificationCountApi(responseJson);
      } else if (apiRequestCallId === this.generateOtpApiID) {
        this.generateOtpApi(responseJson);
      } else if (apiRequestCallId === this.validateOtpApiCallId) {
        this.validateOtpApiCall(responseJson);
      } else if (apiRequestCallId === this.getSelectedFlowRateApiCallId) {
        this.getSelectedFlowRateApiCall(responseJson);
      } else if (apiRequestCallId === this.getSelectedModalFlowRateApiCallId) {
        this.getSelectedModalFlowRateApiCall(responseJson);
      } else if (apiRequestCallId === this.getDeviceReportsApiId) {
        this.getDeviceReportsApi(responseJson, apiRequestCallId);
      } else if (apiRequestCallId === this.getLogsByDeviceIdApi) {
        this.getLogsByDeviceId(responseJson);
      } else if (apiRequestCallId === this.updateTargetLoadApiCall) {
        this.updateTargetLoadApi(responseJson);
      } else if (apiRequestCallId === this.getDevicesLocationWise) {
        this.getDevicesLocationWiseCall(responseJson);
      } else if (apiRequestCallId === this.removeFirebaseTokenApiId) {
        this.removeFirebaseTokenApi(responseJson);
      }
    }
    // Customizable Area End
  }

  clearData(clearType) {
    this.setState({
      clearType: clearType,
      showLoader: true
    });
    const header = {
      "Content-Type": configJSON.dashboarContentType,
      token: localStorage.getItem("token")
    };
    const requestMessage = new Message(getName(MessageEnum.RestAPIRequestMessage));
    this.generateOtpApiID = requestMessage.messageId;
    requestMessage.addData(getName(MessageEnum.RestAPIResponceEndPointMessage), '/bx_block_cfmqttconsumer3/send_email_otp');
    requestMessage.addData(getName(MessageEnum.RestAPIRequestHeaderMessage), JSON.stringify(header));
    requestMessage.addData(getName(MessageEnum.RestAPIRequestMethodMessage), 'GET');
    runEngine.sendMessage(requestMessage.id, requestMessage);
    return true;
  }

  // Customizable Area End
}